import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=65251510&scoped=true&"
import script from "./ContactView.vue?vue&type=script&lang=ts&"
export * from "./ContactView.vue?vue&type=script&lang=ts&"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=65251510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65251510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDivider,VSimpleTable})
